<section class="page-header">
    <div class="page-header__bg" style="background-image: url('/assets/images/post.png')"></div>
    <div class="container">
        <h2 class="page-header__title bw-split-in-left">{{ pageTitleKey | translate }}</h2>
        <ul class="careox-breadcrumb list-unstyled">
            <li><a [routerLink]="['/']">{{ 'HOME' | translate }}</a></li>
            <li>{{ pageTitleKey | translate }}</li>
        </ul>
    </div>
</section>

<section class="blog-one blog-one--page">
    <div class="container">

        <!-- Bandeau filtre actif -->
        <div *ngIf="hasFilter" class="articles__filter-bar">
            <span>
                <i class="icofont-filter"></i>
                <ng-container *ngIf="searchQuery">
                    {{ 'sidebar_filtre_recherche' | translate }} : <strong>{{ searchQuery }}</strong>
                </ng-container>
                <ng-container *ngIf="categorySlug && !searchQuery">
                    {{ 'sidebar_filtre_categorie' | translate }} : <strong>{{ pageTitleKey | translate }}</strong>
                </ng-container>
                <ng-container *ngIf="categoryId && !categorySlug && !searchQuery">
                    {{ 'sidebar_filtre_categorie' | translate }}
                </ng-container>
            </span>
            <a [routerLink]="['/articles']" class="articles__filter-clear">
                <i class="icofont-close"></i> {{ 'sidebar_filtre_effacer' | translate }}
            </a>
        </div>

        <div class="row gutter-y-60">

            <!-- ── Liste des articles ── -->
            <div class="col-lg-8">
                <ng-container *ngIf="!loading; else loadingTpl">

                    <div class="row gutter-y-30" *ngIf="articles.length > 0; else emptyTpl">
                        <div class="col-md-12" *ngFor="let article of articles">
                            <div class="blog-card-list wow fadeInUp" data-wow-duration="1500ms">
                                <div class="blog-card-list__image">
                                    <img [src]="loadImageFeatured(article.featured_image)"
                                         [alt]="translateField(article.title) | slice:0:80">
                                    <img [src]="loadImageFeatured(article.featured_image)"
                                         [alt]="translateField(article.title) | slice:0:80">
                                    <a [routerLink]="['/articles', article.slug]"
                                       class="blog-card-list__image__link">
                                        <span class="sr-only">{{ translateField(article.title) }}</span>
                                    </a>
                                </div>
                                <div class="blog-card-list__content">
                                    <ul class="list-unstyled blog-card-list__meta">
                                        <li class="blog-card-list__meta__cats">
                                            <a *ngIf="article.category"
                                               [routerLink]="['/articles']"
                                               [queryParams]="{category_id: article.category.id}"
                                               style="cursor:pointer">
                                                {{ translateField(article.category.name) }}
                                            </a>
                                        </li>
                                        <li>
                                            <i class="icofont-ui-calendar"></i>
                                            {{ article.created_at | localDate:'fr' }}
                                        </li>
                                    </ul>
                                    <h3 class="blog-card-list__title">
                                        <a [routerLink]="['/articles', article.slug]">
                                            {{ translateField(article.title) | slice:0:80 }}{{ (translateField(article.title).length > 80) ? '…' : '' }}
                                        </a>
                                    </h3>
                                    <p class="blog-card-list__text">
                                        {{ translateField(article.excerpt) | slice:0:200 }}{{ (translateField(article.excerpt).length > 200) ? '…' : '' }}
                                    </p>
                                    <a [routerLink]="['/articles', article.slug]" class="blog-card-list__link">
                                        <span class="blog-card-list__link__front">
                                            <span class="icofont-double-right"></span>
                                        </span>
                                        <span class="blog-card-list__link__back">
                                            <span class="icofont-double-right"></span>{{ 'MORE' | translate }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- ── Pagination ── -->
                        <div class="col-md-12" *ngIf="totalPages > 1">
                            <nav class="articles-pagination">

                                <!-- Précédent -->
                                <button class="articles-page-btn"
                                        [disabled]="page <= 1"
                                        (click)="loadPage(page - 1)"
                                        [title]="'sidebar_precedent' | translate">
                                    <i class="icofont-double-left"></i>
                                </button>

                                <!-- Première page + ellipsis -->
                                <button *ngIf="page > 3"
                                        class="articles-page-btn"
                                        (click)="loadPage(1)">1</button>
                                <span *ngIf="page > 4" class="articles-page-ellipsis">…</span>

                                <!-- Fenêtre de pages (±2 autour de la courante) -->
                                <button *ngFor="let p of pages"
                                        class="articles-page-btn"
                                        [class.active]="p === page"
                                        (click)="loadPage(p)">{{ p }}</button>

                                <!-- Ellipsis + dernière page -->
                                <span *ngIf="page < totalPages - 3" class="articles-page-ellipsis">…</span>
                                <button *ngIf="page < totalPages - 2"
                                        class="articles-page-btn"
                                        (click)="loadPage(totalPages)">{{ totalPages }}</button>

                                <!-- Suivant -->
                                <button class="articles-page-btn"
                                        [disabled]="page >= totalPages"
                                        (click)="loadPage(page + 1)"
                                        [title]="'sidebar_suivant' | translate">
                                    <i class="icofont-double-right"></i>
                                </button>

                            </nav>
                        </div>

                    </div>

                    <!-- Aucun résultat -->
                    <ng-template #emptyTpl>
                        <div class="articles__empty">
                            <i class="icofont-newspaper"></i>
                            <p>{{ 'sidebar_aucun_article' | translate }}</p>
                            <a [routerLink]="['/articles']" class="careox-btn">
                                {{ 'sidebar_voir_tous' | translate }}
                            </a>
                        </div>
                    </ng-template>

                </ng-container>

                <!-- Chargement -->
                <ng-template #loadingTpl>
                    <app-loading></app-loading>
                </ng-template>
            </div>

            <!-- ── Sidebar ── -->
            <div class="col-lg-4">
                <app-sidebar-blog></app-sidebar-blog>
            </div>

        </div>
    </div>
</section>
